export const GET_ALL_ROOMS = `${process.env.REACT_APP_API_URL}/talk/getAllRooms`;
export const GET_SUGGESTED_USERS = `${process.env.REACT_APP_API_URL_RESSOURCES}/users/messagerie/v2/all/sugesstions/get`;
